import { AnimatePresence, motion } from "framer-motion";
import {
  CharacterLimitIcon,
  ConfluenceIcon,
  DelIconSvg,
  EditAppIcon,
  GoogleDriveIcon,
  IErrIconSvg,
  NotionIcon,
  RetrainBtnIcon,
  SalesforceIcon,
  TrainingProgressIcon,
  ViewDetailsIcon,
} from "../AiBotAssets";
import { DelIcon } from "@/assets/AiBotAssets";
import useFormatNumber from "@/hooks/UseFormatNumber";
import { useDispatch, useSelector } from "react-redux";
import type { State } from "@/redux/Types";
import { useNavigate } from "react-router-dom";
import { userSlice } from "@/redux/User";
import { ConfigId } from "@/constants/ConfigData";
import { useContext, useMemo, useRef, useState } from "react";
import { BotContext } from "../../store";
import useGooglePickerConfig from "@/pages/omni-builder/react-query/configs/useGooglePickerConfig";
import useNotionConfig from "@/pages/omni-builder/react-query/configs/useNotionConfig";
import useConfluenceConfig from "@/pages/omni-builder/react-query/configs/useConfluenceConfig";
import useSalesForceConfig from "@/pages/omni-builder/react-query/configs/useSalesForceConfig";
import useStore from "@/pages/omni-builder/store";
import ThreeDot from "@/components/loaders/ThreeDot";
import { statuses } from "../AIBotTab_1";
import moment from "moment";
import { createPortal } from "react-dom";
import Pagination from "../../Pagination";
import ModalWrapper from "../ModalWrapper";
import BooleanModal from "@/components/builder/BooleanModal";
import { axiosPost } from "@/services/axiosService";
import { debounce } from "lodash";
const NativeApps = ({
  characterUsed,
  characterLimit,
  inProcess,
  deleteTrainDocument,
  openGooglePicker,
  botData,
  isRetraining,
  setSelectedStatus,
  retryRejectedLinks,
  isPostTrainingDelay,
  handleResync,
  handleDropdowns,
  handleViewDetails,
  handleFileRemove,
  dropdowns,
  isOld,
}) => {
  const plan: any = useSelector((state: State) => state.user.plan);
  const fromOutgrow = useSelector((state: State) => state.user.fromOutgrow);
  const router = useNavigate();
  const dispatch = useDispatch();
  const [store, storeDispatch] = useContext(BotContext);
  const setOpenConfigModalId = useStore((state) => state.setOpenConfigModalId);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [resyncData, setResyncData] = useState<any>([]);
  const [nativeAppSearch, setNativeAppSearch] = useState<{
    [key: string]: string;
  }>({});
  const [nativeAppPage, setNativeAppPage] = useState<{ [key: string]: number }>(
    {},
  );
  const [leaveModal, setLeaveModal] = useState(false);
  const [buyAddOn, setBuyAddOn] = useState(false);
  // Restore local dropdownPosition state
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });
  const [fileDeleteLoader, setFileDeleteLoader] = useState<
    Record<string, string[]>
  >({});
  const [googleAuthLoading, setGoogleAuthLoading] = useState(false);

  const { data: googlePickerConfigs, isLoading: googleLoading } =
    useGooglePickerConfig();
  const { isLoading: notionLoading, data: notionConfigs } = useNotionConfig();
  const { isLoading: confluenceLoading, data: confluenceConfigs } =
    useConfluenceConfig();
  const { isLoading: salesforceLoading, data: salesforceConfigs } =
    useSalesForceConfig();
  const trainedSource = store.botData.aiSource;
  const itemsPerPage = 10;
  const [selectedItems, setSelectedItems] = useState<Map<string, Set<string>>>(
    new Map(),
  );
  const [isAllSelected, setIsAllSelected] = useState<Map<string, boolean>>(
    new Map(),
  );
  const dropdownRef = useRef<any>({});
  const notion = botData.aiSource?.notion || [];
  const confluence = botData.aiSource?.confluence || [];
  const googlepicker = botData.aiSource?.googlepicker || [];
  const salesforce = botData.aiSource?.salesforce || [];
  const Configs = {
    notion: {
      config: notionConfigs,
      loading: notionLoading,
    },
    confluence: {
      config: confluenceConfigs,
      loading: confluenceLoading,
    },
    salesforce: {
      config: salesforceConfigs?.length ? salesforceConfigs : null,
      loading: salesforceLoading,
    },
    googlepicker: {
      config: googlePickerConfigs,
      loading: googleLoading || googleAuthLoading,
    },
  };

  const handleConfigModal = async (key) => {
    if (key == "googlepicker") {
      setGoogleAuthLoading(true);
      await openGooglePicker(setOpenConfigModalId);
      setGoogleAuthLoading(false);
    } else storeDispatch({ type: "set-openConfigModalId", configId: key });
  };

  const rejectedLinksMap = useMemo(() => {
    const getRejected = (arr) =>
      Array.isArray(arr)
        ? arr.filter((file) => file.status === "File Rejected")
        : [];

    return {
      notion: getRejected(notion),
      confluence: getRejected(confluence),
      googlepicker: getRejected(googlepicker),
      salesforce: getRejected(salesforce),
    };
  }, [notion, confluence, googlepicker, salesforce]);

  const handleAllCheckToggle = (cardKey) => {
    const allItems = trainedSource[cardKey];
    const selectableItems = allItems.filter(
      (i) => i.status !== "In Progress..",
    );
    const currentAllChecked = isAllSelected.get(cardKey) || false;

    setSelectedItems((prev) => {
      const newMap = new Map(prev);
      if (!currentAllChecked) {
        const newSet: any = new Set(
          selectableItems.map((i) => i.googlePickerId || i.id || i.title),
        );
        newMap.set(cardKey, newSet);
      } else {
        newMap.set(cardKey, new Set());
      }
      return newMap;
    });

    setIsAllSelected((prev) => {
      const newMap = new Map(prev);
      newMap.set(cardKey, !currentAllChecked);
      return newMap;
    });

    setResyncData((prevData: Record<string, string[]>) => {
      let updatedItems: string[];
      if (!currentAllChecked) {
        // Select all
        updatedItems = selectableItems.map((i) => ({
          url: i.title,
          status: i.status,
        }));
      } else {
        // Deselect all
        updatedItems = [];
      }

      return {
        ...prevData,
        [cardKey]: updatedItems,
      };
    });
  };

  const handleSingleItemToggle = (cardKey, itemId, title, status) => {
    setResyncData((prevData: Record<string, any[]>) => {
      const prevItems = prevData[cardKey] || [];

      const isAlreadyAdded = prevItems?.filter((t) => t.url === title);

      let updatedItems: any[];
      if (isAlreadyAdded[0]) {
        // remove
        updatedItems = prevItems?.filter((t) => t.url !== title);
      } else {
        // add
        updatedItems = [
          ...prevItems,
          {
            url: title,
            status,
          },
        ];
      }

      return {
        ...prevData,
        [cardKey]: updatedItems,
      };
    });

    setSelectedItems((prev) => {
      const newMap = new Map(prev);
      const currentCardItems = newMap.get(cardKey) || new Set();

      if (currentCardItems.has(itemId)) {
        currentCardItems.delete(itemId);
      } else {
        currentCardItems.add(itemId);
      }

      newMap.set(cardKey, currentCardItems);

      // Update all checked status for this card
      const allItems = trainedSource[cardKey];
      const selectableItems = allItems.filter(
        (i) => i.status !== "In Progress..",
      );
      setIsAllSelected((prevCheck) => {
        const newCheck: any = new Map(prevCheck);
        newCheck.set(cardKey, currentCardItems.size === selectableItems.length);
        return newCheck;
      });

      return newMap;
    });
  };

  const handleNativeAppsResync = (currentResyncItems, key) => {
    const curDataset: any[] = [];
    const resyncItems: any = [];
    let authId: any;
    const resyncAll = currentResyncItems?.filter(
      (d) => d.status !== "Re-syncing" && d.status !== "In Progress",
    );
    setSelectedItems((prev) => {
      const newMap = new Map(prev);
      newMap.set(key, new Set());
      return newMap;
    });
    setIsAllSelected((prev) => {
      const newMap = new Map(prev);
      newMap.set(key, false);
      return newMap;
    });
    setResyncData([]);
    if (resyncAll?.length === 0) return;
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "success",
        message: `${resyncAll.length} links added to resync.`,
      }),
    );
    for (const item of store.botData?.aiSource?.[key] || []) {
      const urlItem = resyncAll?.filter((t) => t.url === item.title);
      if (urlItem[0]) {
        authId = item.authId;
        resyncItems.push(urlItem[0].url);
        curDataset.push({
          ...item,
          status: "Re-syncing",
        });
      } else {
        curDataset.push(item);
      }
    }

    storeDispatch({
      type: "set-aiSource",
      dataKey: key,
      dataSet: curDataset,
    });
    const sourcesToProcess = ["confluence", "notion"];

    const payload = {
      links: {
        [key]: resyncItems,
      },
      botCustomId: botData.botCustomId,
      botCreatedAt: botData.createdAt,
      ...(sourcesToProcess.includes(key) && {
        authId,
      }),
    };

    axiosPost("/ai/resync-multiple", payload);
  };

  const debouncedHandleNativeAppsResync = debounce(handleNativeAppsResync, 500);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="fx-d-col source_native_apps flex h-full w-full pb-[20px]"
    >
      <h3 className="!mb-[10px] flex items-center gap-[10px]">
        Native Apps
        {isOld && (
          <div className="character-count-wrapper flex items-center gap-[10px]">
            <span className="!ms-[0px] h-[24px] w-[1px] bg-[#666] opacity-[0.3]"></span>
            <p
              className={`character-count pointer relative z-[5] flex items-center gap-[4px] rounded-[5px] px-[8px] py-[6px] text-[13px] font-medium capitalize leading-normal ${useFormatNumber(characterUsed) === useFormatNumber(characterLimit) ? "bg-[#FFE8E9] text-[#fb5f66]" : "bg-[#FEF2CC] text-[#9A6815]"} `}
            >
              <CharacterLimitIcon
                color={
                  useFormatNumber(characterUsed) ===
                  useFormatNumber(characterLimit)
                    ? "#fb5f66"
                    : "#9A6815"
                }
              />
              {characterLimit === 0 ? (
                <div className="yellow-loader"></div>
              ) : (
                `${useFormatNumber(characterUsed)} / ${useFormatNumber(characterLimit)}`
              )}
              <div className="none absolute left-[0] top-[35px] z-[1] w-[280px] cursor-default flex-col items-center gap-[10px] rounded-[8px] bg-[#222] p-[10px]">
                {useFormatNumber(characterUsed) ===
                useFormatNumber(characterLimit) ? (
                  <p className="text-center text-[12px] font-normal normal-case not-italic leading-[17px] text-[#fb5f66]">
                    Your current plan doesn't support more than
                    <b className="font-medium">
                      {" "}
                      {useFormatNumber(characterLimit)} Characters.{" "}
                    </b>
                    {plan.name !== "Professional"
                      ? "Upgrade to the Professional plan to unlock this feature."
                      : "If you want more, you have to buy the add-on."}
                  </p>
                ) : (
                  <p className="text-center text-[12px] font-normal normal-case not-italic leading-[17px] text-white/80">
                    Agents can use a maximum of <br />
                    <b className="font-medium">
                      {useFormatNumber(characterLimit)} Characters
                    </b>
                    , including link content. Anything over that limit won't be
                    used.
                  </p>
                )}
                {plan.name !== "Professional" ? (
                  <button
                    className="pointer h-[30px] w-full rounded-[8px] bg-[#fb5f66] text-[12px] font-normal leading-normal text-white"
                    onClick={() => {
                      setBuyAddOn(false);
                      setLeaveModal(true);
                    }}
                  >
                    Upgrade Plan
                  </button>
                ) : (
                  <button
                    className="pointer h-[30px] w-full rounded-[8px] bg-[#fb5f66] text-[12px] font-normal leading-normal text-white"
                    onClick={() => {
                      setBuyAddOn(true);
                      setLeaveModal(true);
                    }}
                  >
                    Buy add-on
                  </button>
                )}
              </div>
            </p>
          </div>
        )}
      </h3>

      <div className="apps_wrap grid h-full w-full gap-10 overflow-auto">
        {appCards.map((item, index) => {
          const searchValue = nativeAppSearch[item.key] || "";
          const pageValue = nativeAppPage[item.key] || 1;
          const allDocs = trainedSource[item.key] || [];
          const filteredDocs = searchValue
            ? allDocs.filter((doc) =>
                (doc.title || doc.name || "")
                  .toLowerCase()
                  .includes(searchValue.toLowerCase()),
              )
            : allDocs;
          const paginatedDocs = filteredDocs.slice(
            (pageValue - 1) * itemsPerPage,
            pageValue * itemsPerPage,
          );
          // Get current card's selection state
          const currentCardSelectedItems =
            selectedItems.get(item.key) || new Set();
          const currentCardIsAllSelected = isAllSelected.get(item.key) || false;

          const currentResyncItems = resyncData[item.key];

          return (
            <div className="source_native_app_card" key={item.key}>
              <div className="app grid gap-10">
                <div className="w-100 flex items-center justify-between">
                  <div className="right_content flex items-center gap-[12px]">
                    {item.icon}
                    <div>
                      <h4>{item.title}</h4>
                      <p>{item.subtitle}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-[10px]">
                    {expandedIndex === index &&
                    trainedSource &&
                    currentCardSelectedItems?.size > 0 ? (
                      <>
                        <button
                          className={`flex items-center gap-[4px] text-red-500 ${inProcess ? "pointer-events-none opacity-50" : ""}`}
                          onClick={async () => {
                            if (currentCardSelectedItems.size <= 0) return;
                            const allItems = [...trainedSource[item.key]];
                            const selectedItems = allItems.filter((i) =>
                              currentCardSelectedItems.has(
                                i.googlePickerId || i.id || i.title,
                              ),
                            );

                            if (selectedItems.length === 0) return;
                            await deleteTrainDocument({
                              source: selectedItems,
                              sourceType: item.key,
                            });

                            setSelectedItems((prev) => {
                              const newMap = new Map(prev);
                              newMap.set(item.key, new Set());
                              return newMap;
                            });
                            setIsAllSelected((prev) => {
                              const newMap = new Map(prev);
                              newMap.set(item.key, false);
                              return newMap;
                            });
                          }}
                        >
                          <DelIcon />
                          {currentCardSelectedItems.size === 1
                            ? "Delete"
                            : "Delete All"}
                        </button>
                        {currentResyncItems &&
                          currentResyncItems.length > 0 && (
                            <button
                              className={`flex items-center gap-[4px] text-red-500 ${inProcess ? "pointer-events-none opacity-50" : ""}`}
                              onClick={async () => {
                                if (currentResyncItems.length <= 0) return;

                                debouncedHandleNativeAppsResync(
                                  currentResyncItems,
                                  item.key,
                                );
                              }}
                            >
                              <svg
                                className="cursor-pointer"
                                width={17}
                                height={16}
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_841_2984)">
                                  <g>
                                    <path
                                      d="M8.40664 13.6994C6.83512 13.6994 5.41016 13.0601 4.378 12.0279L5.88744 10.5186C6.11592 10.2901 5.95416 9.89941 5.63112 9.89941H1.45832C1.28548 9.89941 1.11973 9.96807 0.997513 10.0903C0.8753 10.2125 0.806641 10.3783 0.806641 10.5511V14.7239C0.806641 15.0471 1.19736 15.2087 1.42584 14.9802L3.03512 13.3709C4.41144 14.7469 6.31128 15.5994 8.40664 15.5994C12.3441 15.5994 15.5918 12.5895 15.9698 8.74981C16.0095 8.34661 15.6854 7.99941 15.2802 7.99941H14.7602C14.4052 7.99941 14.1114 8.26853 14.0729 8.62149C13.762 11.4729 11.3394 13.6994 8.40664 13.6994ZM8.40664 0.399414C4.46904 0.399414 1.22152 3.40917 0.843441 7.24901C0.803761 7.65221 1.12792 7.99941 1.53304 7.99941H2.05304C2.40808 7.99941 2.70184 7.73029 2.7404 7.37733C3.05128 4.52597 5.47384 2.29941 8.40664 2.29941C9.97816 2.29941 11.4031 2.93877 12.4353 3.97077L10.9258 5.48021C10.6974 5.70869 10.8591 6.09941 11.1822 6.09941H15.355C15.5278 6.09941 15.6936 6.03076 15.8158 5.90854C15.938 5.78633 16.0066 5.62057 16.0066 5.44773V1.27493C16.0066 0.951734 15.6159 0.790134 15.3874 1.01861L13.7782 2.62789C12.4018 1.25189 10.502 0.399414 8.40664 0.399414Z"
                                      fill="#fb5f66"
                                    />
                                  </g>
                                </g>
                                <defs>
                                  <clipPath id="clip0_841_2984">
                                    <rect
                                      width={16}
                                      height={16}
                                      fill="white"
                                      transform="translate(0.40625)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              Resync
                            </button>
                          )}
                      </>
                    ) : Configs[item.key].config ? (
                      <span
                        className="setting-icon flex cursor-pointer items-center gap-[4px]"
                        onClick={() => handleConfigModal(item.key)}
                      >
                        <EditAppIcon /> Settings
                      </span>
                    ) : (
                      <button
                        className="flex items-center gap-[4px]"
                        onClick={() => handleConfigModal(item.key)}
                        disabled={
                          Configs[item.key].loading ||
                          store.openConfigModalId === item.key
                        }
                      >
                        {Configs[item.key].loading ||
                        store.openConfigModalId === item.key ? (
                          <div className="fx al-fx-end jstfy-cnt threedot-loader gap-2">
                            Loading <ThreeDot />
                          </div>
                        ) : (
                          <>
                            <svg
                              width={16}
                              height={17}
                              viewBox="0 0 16 17"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_2220_129287)">
                                <path
                                  d="M13.1476 4.435H11.3881V1.75C11.3881 1.55109 11.309 1.36032 11.1684 1.21967C11.0277 1.07902 10.837 1 10.6381 1C10.4391 1 10.2484 1.07902 10.1077 1.21967C9.96708 1.36032 9.88806 1.55109 9.88806 1.75V4.435H6.11106V1.75C6.11106 1.55109 6.03204 1.36032 5.89139 1.21967C5.75074 1.07902 5.55997 1 5.36106 1C5.16215 1 4.97138 1.07902 4.83073 1.21967C4.69008 1.36032 4.61106 1.55109 4.61106 1.75V4.435H2.85156C2.65265 4.435 2.46188 4.51402 2.32123 4.65467C2.18058 4.79532 2.10156 4.98609 2.10156 5.185C2.10156 5.38391 2.18058 5.57468 2.32123 5.71533C2.46188 5.85598 2.65265 5.935 2.85156 5.935H3.42156V8.04C3.42156 10.3085 5.08156 12.1915 7.24956 12.551V15.75C7.24956 15.9489 7.32858 16.1397 7.46923 16.2803C7.60988 16.421 7.80065 16.5 7.99956 16.5C8.19847 16.5 8.38924 16.421 8.52989 16.2803C8.67054 16.1397 8.74956 15.9489 8.74956 15.75V12.551C10.9176 12.1915 12.5776 10.3085 12.5776 8.04V5.935H13.1476C13.3465 5.935 13.5372 5.85598 13.6779 5.71533C13.8185 5.57468 13.8976 5.38391 13.8976 5.185C13.8976 4.98609 13.8185 4.79532 13.6779 4.65467C13.5372 4.51402 13.3465 4.435 13.1476 4.435ZM11.0776 8.04C11.0776 9.7375 9.69706 11.118 7.99956 11.118C6.30206 11.118 4.92156 9.7375 4.92156 8.04V5.935H11.0776V8.04Z"
                                  fill="#FB5F66"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_2220_129287">
                                  <rect
                                    width={16}
                                    height={16}
                                    fill="white"
                                    transform="translate(0 0.75)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            Connect
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>
                {trainedSource && !!trainedSource[item.key]?.length && (
                  <div
                    className={`pd-15 imported_docs ${expandedIndex === index ? "native_app_expanded" : ""}`}
                  >
                    <div
                      className="left-[0] right-[0] flex cursor-pointer items-center justify-between"
                      onClick={() =>
                        setExpandedIndex((prevIndex) =>
                          prevIndex === index ? null : index,
                        )
                      }
                    >
                      <h4 className="mb-0">Imported Documents</h4>
                      <div
                        className="flex items-center gap-[8px]"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {expandedIndex === index && (
                          <div className="search_div border-[rgba(0, 0, 0, 0.10)] mr-2 flex w-[220px] items-center gap-10 rounded-[10px] border border-solid bg-white px-[12px] py-[8px]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={15}
                              height={14}
                              viewBox="0 0 15 14"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_190_16528)">
                                <path
                                  d="M5.60625 0C6.98538 0 8.30802 0.547855 9.28321 1.52304C10.2584 2.49823 10.8063 3.82087 10.8063 5.2C10.8063 6.488 10.3342 7.672 9.55825 8.584L9.77425 8.8H10.4062L14.4062 12.8L13.2063 14L9.20625 10V9.368L8.99025 9.152C8.04669 9.95742 6.84682 10.3999 5.60625 10.4C4.22712 10.4 2.90448 9.85215 1.92929 8.87696C0.954105 7.90177 0.40625 6.57913 0.40625 5.2C0.40625 3.82087 0.954105 2.49823 1.92929 1.52304C2.90448 0.547855 4.22712 0 5.60625 0ZM5.60625 1.6C3.60625 1.6 2.00625 3.2 2.00625 5.2C2.00625 7.2 3.60625 8.8 5.60625 8.8C7.60625 8.8 9.20625 7.2 9.20625 5.2C9.20625 3.2 7.60625 1.6 5.60625 1.6Z"
                                  fill="#444444"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_190_16528">
                                  <rect
                                    width={15}
                                    height={14}
                                    fill="white"
                                    transform="translate(0.40625)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <input
                              type="text"
                              placeholder={`Search ${item.title}`}
                              className="h-[unset] border-none bg-transparent text-[14px] outline-none"
                              value={nativeAppSearch[item.key] || ""}
                              onChange={(e) => {
                                setNativeAppSearch((prev) => ({
                                  ...prev,
                                  [item.key]: e.target.value,
                                }));
                                setNativeAppPage((prev) => ({
                                  ...prev,
                                  [item.key]: 1,
                                }));
                              }}
                            />
                          </div>
                        )}
                        <svg
                          onClick={() =>
                            setExpandedIndex((prevIndex) =>
                              prevIndex === index ? null : index,
                            )
                          }
                          className={`cp ${expandedIndex === index ? "" : "rotate-180"}`}
                          xmlns="http://www.w3.org/2000/svg"
                          width={11}
                          height={11}
                          viewBox="0 0 11 11"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_2220_130208)">
                            <path
                              d="M0.483887 7.73438L5.69222 2.31771L10.9006 7.73437L0.483887 7.73438Z"
                              fill="#444444"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2220_130208">
                              <rect
                                width={9.61538}
                                height={10}
                                fill="white"
                                transform="matrix(1 0 0 -1 0.884766 10.2344)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <AnimatePresence>
                      {expandedIndex === index && (
                        <motion.div
                          initial={{
                            opacity: 0,
                            height: 0,
                            overflow: "hidden",
                          }}
                          animate={{
                            opacity: 1,
                            height: "auto",
                            overflow: "scroll",
                          }}
                          exit={{
                            opacity: 0,
                            height: 0,
                            overflow: "hidden",
                          }}
                          transition={{
                            duration: 0.3,
                            ease: "easeInOut",
                          }}
                        >
                          <div className="trained_links_wrapper p-relative new-scrollbar mt-10 bg-white">
                            <table
                              className={`links_table new-scrollbar w-100 mt-0 flex flex-col overflow-y-auto ${inProcess && "pointer-events-none opacity-50"}`}
                            >
                              {rejectedLinksMap[item.key] &&
                                rejectedLinksMap[item.key].length > 0 && (
                                  <div className="retrain_err sticky left-0 top-0 flex items-center justify-between rounded-t-[8px]">
                                    <div className="flex items-center gap-[8px]">
                                      <IErrIconSvg />
                                      <p className="mt-0">
                                        <span className="font-medium">
                                          {rejectedLinksMap[item.key].length}{" "}
                                          files couldn't be trained
                                        </span>{" "}
                                        due to formatting errors or
                                        accessibility issues.
                                      </p>
                                    </div>
                                    <div className="flex items-center gap-[8px]">
                                      {isRetraining ? (
                                        <div className="rotating-svg">
                                          <TrainingProgressIcon />
                                        </div>
                                      ) : (
                                        <button
                                          className="flex items-center gap-[8px]"
                                          onClick={() => {
                                            setSelectedStatus({
                                              text: "",
                                              icon: null,
                                            });
                                            retryRejectedLinks(
                                              rejectedLinksMap[item.key],
                                              item.key,
                                            );
                                          }}
                                        >
                                          <RetrainBtnIcon /> Retrain
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )}
                              <thead
                                className={`sticky top-0 z-[1] flex w-full rounded-t-[8px] bg-[#f2f2f2] ${
                                  rejectedLinksMap[item.key] &&
                                  rejectedLinksMap[item.key].length > 0
                                    ? "!rounded-t-[0px]"
                                    : ""
                                }`}
                              >
                                <tr>
                                  <th className="flex items-center">
                                    {paginatedDocs.length > 0 && (
                                      <label className="checkbox-container link-mark mb-0 flex w-[16px] items-center">
                                        <input
                                          className="bot-check h-[unset]"
                                          type="checkbox"
                                          checked={currentCardIsAllSelected}
                                          id={`checkbox-${item.key}`}
                                          disabled={isPostTrainingDelay}
                                        />
                                        <span
                                          className="mark"
                                          onClick={() =>
                                            handleAllCheckToggle(item.key)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                          >
                                            <rect
                                              width="16"
                                              height="16"
                                              rx="5"
                                              fill="#FB5F66"
                                            />
                                            <path
                                              d="M11.6923 4.11088C11.3794 3.90411 10.9616 3.99489 10.7589 4.31353L6.9773 10.2532L5.13304 8.51563C4.85926 8.25774 4.43251 8.2747 4.17942 8.55368C3.92634 8.83243 3.94298 9.26775 4.21677 9.52541L6.63828 11.8068C6.63828 11.8068 6.70779 11.8677 6.73996 11.8891C6.85334 11.9642 6.98067 12 7.10665 12C7.32757 12 7.54421 11.8895 7.67356 11.6864L11.8912 5.06198C12.0941 4.74334 12.005 4.31742 11.6923 4.11088Z"
                                              fill="white"
                                            />
                                          </svg>
                                        </span>
                                      </label>
                                    )}
                                    <span className="pl-[16px] font-medium">
                                      Document Name
                                    </span>
                                  </th>
                                  <th>Status</th>
                                  <th className="order_drp relative flex cursor-pointer items-center gap-6">
                                    <span className="flex items-center gap-[8px] font-medium">
                                      Characters
                                    </span>
                                  </th>

                                  <th className="order_drp relative flex cursor-pointer items-center gap-6">
                                    <span className="flex items-center gap-[8px] font-medium">
                                      Last Updated
                                    </span>
                                  </th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody
                                className={`grey-scrollbar flex !h-max min-h-[180px] flex-col items-center justify-start bg-white`}
                              >
                                {paginatedDocs.length > 0 ? (
                                  paginatedDocs.map((innerItem, itemIndex) => {
                                    return (
                                      <tr
                                        // className={`w-100 flex flex-col ${data?.status === "In Progress" || inProcess ? "pointer-events-none opacity-50" : ""}`}
                                        className={`w-100 flex flex-col ${inProcess ? "pointer-events-none opacity-50" : ""}`}
                                        key={`trained-${innerItem?.googlePickerId || innerItem.id || itemIndex}`}
                                      >
                                        <td className="flex items-center">
                                          <label className="checkbox-container link-mark mb-0 flex w-[16px] items-center">
                                            <input
                                              className="bot-check h-[unset]"
                                              type="checkbox"
                                              id={`checkbox_${item.key}_${innerItem?.googlePickerId || innerItem.id || innerItem.title}`}
                                              checked={currentCardSelectedItems.has(
                                                innerItem?.googlePickerId ||
                                                  innerItem.id ||
                                                  innerItem.title,
                                              )}
                                              disabled={
                                                isPostTrainingDelay
                                                // ||
                                                // innerItem.status ===
                                                //   "In Progress"
                                              }
                                            />
                                            <span
                                              className="mark !w-[18px]"
                                              onClick={() =>
                                                handleSingleItemToggle(
                                                  item.key,
                                                  innerItem?.googlePickerId ||
                                                    innerItem.id ||
                                                    innerItem.title,
                                                  innerItem.title,
                                                  innerItem.status,
                                                )
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                              >
                                                <rect
                                                  width="16"
                                                  height="16"
                                                  rx="5"
                                                  fill="#FB5F66"
                                                />
                                                <path
                                                  d="M11.6923 4.11088C11.3794 3.90411 10.9616 3.99489 10.7589 4.31353L6.9773 10.2532L5.13304 8.51563C4.85926 8.25774 4.43251 8.2747 4.17942 8.55368C3.92634 8.83243 3.94298 9.26775 4.21677 9.52541L6.63828 11.8068C6.63828 11.8068 6.70779 11.8677 6.73996 11.8891C6.85334 11.9642 6.98067 12 7.10665 12C7.32757 12 7.54421 11.8895 7.67356 11.6864L11.8912 5.06198C12.0941 4.74334 12.005 4.31742 11.6923 4.11088Z"
                                                  fill="white"
                                                />
                                              </svg>
                                            </span>
                                          </label>
                                          <span
                                            className="ml-[16px] overflow-hidden whitespace-nowrap"
                                            onMouseEnter={(e) => {
                                              const container = e.currentTarget;
                                              const inner =
                                                container.querySelector(
                                                  ".scrolling-text",
                                                ) as HTMLElement | null;
                                              if (inner) {
                                                const scrollDistance =
                                                  inner.scrollWidth -
                                                  container.offsetWidth;
                                                if (scrollDistance > 0) {
                                                  const speed = 100;
                                                  const duration =
                                                    scrollDistance / speed;
                                                  inner.style.transition = `transform ${duration}s linear`;
                                                  inner.style.transform = `translateX(-${scrollDistance}px)`;
                                                }
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              const container = e.currentTarget;
                                              const inner =
                                                container.querySelector(
                                                  ".scrolling-text",
                                                ) as HTMLElement | null;
                                              if (inner) {
                                                inner.style.transition =
                                                  "transform 0.3s ease-out";
                                                inner.style.transform =
                                                  "translateX(0)";
                                              }
                                            }}
                                          >
                                            <div className="scrolling-text whitespace-nowrap">
                                              {
                                                innerItem[
                                                  item.titleKey ?? "title"
                                                ]
                                              }
                                            </div>
                                          </span>
                                        </td>
                                        <td
                                          className={`flex items-center gap-[6px] whitespace-nowrap ${innerItem?.status === "In Progress" && "rotating-svg"} ${innerItem?.status === "Re-syncing" && "resyncing-svg"}`}
                                        >
                                          {
                                            statuses.find(
                                              (item) =>
                                                item.text === innerItem.status,
                                            )?.iconComponent
                                          }
                                          {innerItem.status}
                                        </td>

                                        <td>
                                          {innerItem?.characterCount ??
                                            innerItem?.text?.length ??
                                            innerItem.size ??
                                            0}
                                        </td>
                                        <td>
                                          {isNaN(
                                            Number(innerItem.lastSyncTime),
                                          ) || !innerItem.lastSyncTime
                                            ? "..."
                                            : moment(
                                                Number(innerItem.lastSyncTime),
                                              ).fromNow()}
                                        </td>
                                        <td className="flex items-center justify-between">
                                          <span
                                            className={`resync_icon relative ${innerItem.status === "Re-syncing" && "resyncing-svg"}`}
                                            onClick={() =>
                                              handleResync(innerItem, item.key)
                                            }
                                          >
                                            <svg
                                              className="cursor-pointer"
                                              width={17}
                                              height={16}
                                              viewBox="0 0 17 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g clipPath="url(#clip0_841_2984)">
                                                <g opacity={0.5}>
                                                  <path
                                                    d="M8.40664 13.6994C6.83512 13.6994 5.41016 13.0601 4.378 12.0279L5.88744 10.5186C6.11592 10.2901 5.95416 9.89941 5.63112 9.89941H1.45832C1.28548 9.89941 1.11973 9.96807 0.997513 10.0903C0.8753 10.2125 0.806641 10.3783 0.806641 10.5511V14.7239C0.806641 15.0471 1.19736 15.2087 1.42584 14.9802L3.03512 13.3709C4.41144 14.7469 6.31128 15.5994 8.40664 15.5994C12.3441 15.5994 15.5918 12.5895 15.9698 8.74981C16.0095 8.34661 15.6854 7.99941 15.2802 7.99941H14.7602C14.4052 7.99941 14.1114 8.26853 14.0729 8.62149C13.762 11.4729 11.3394 13.6994 8.40664 13.6994ZM8.40664 0.399414C4.46904 0.399414 1.22152 3.40917 0.843441 7.24901C0.803761 7.65221 1.12792 7.99941 1.53304 7.99941H2.05304C2.40808 7.99941 2.70184 7.73029 2.7404 7.37733C3.05128 4.52597 5.47384 2.29941 8.40664 2.29941C9.97816 2.29941 11.4031 2.93877 12.4353 3.97077L10.9258 5.48021C10.6974 5.70869 10.8591 6.09941 11.1822 6.09941H15.355C15.5278 6.09941 15.6936 6.03076 15.8158 5.90854C15.938 5.78633 16.0066 5.62057 16.0066 5.44773V1.27493C16.0066 0.951734 15.6159 0.790134 15.3874 1.01861L13.7782 2.62789C12.4018 1.25189 10.502 0.399414 8.40664 0.399414Z"
                                                    fill="#6A6A65"
                                                  />
                                                </g>
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_841_2984">
                                                  <rect
                                                    width={16}
                                                    height={16}
                                                    fill="white"
                                                    transform="translate(0.40625)"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <p className="sm-tooltip flex-cnt">
                                              <span className="sm-tooltip_text">
                                                Resync
                                              </span>
                                            </p>
                                          </span>
                                          <span
                                            ref={(el) => {
                                              if (!dropdownRef.current)
                                                dropdownRef.current = {};
                                              dropdownRef.current[
                                                `trainedappsAction-${itemIndex}`
                                              ] = el;
                                            }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              const rect =
                                                e.currentTarget.getBoundingClientRect();
                                              setDropdownPosition({
                                                top:
                                                  rect.bottom + window.scrollY,
                                                left: rect.right - 142,
                                                width: rect.width,
                                              });
                                              handleDropdowns(
                                                itemIndex,
                                                "trainedappsAction",
                                                !dropdowns[itemIndex]
                                                  ?.trainedappsAction,
                                              );
                                            }}
                                            onMouseLeave={() =>
                                              handleDropdowns(
                                                itemIndex,
                                                "trainedappsAction",
                                                false,
                                              )
                                            }
                                            className={`files_action_drp cp relative flex h-[30px] w-[30px] items-center justify-center ${paginatedDocs.length > 2 ? "upper_drp" : ""} ${dropdowns[itemIndex]?.trainedappsAction ? "show-before" : ""}`}
                                          >
                                            <svg
                                              className="cursor-pointer"
                                              width={17}
                                              height={16}
                                              viewBox="0 0 17 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g clipPath="url(#clip0_841_17)">
                                                <path
                                                  d="M8.40494 3.33331C9.32541 3.33331 10.0716 2.58713 10.0716 1.66666C10.0716 0.746187 9.32541 0 8.40494 0C7.48447 0 6.73828 0.746187 6.73828 1.66666C6.73828 2.58713 7.48447 3.33331 8.40494 3.33331Z"
                                                  fill="#444444"
                                                />
                                                <path
                                                  d="M8.40494 9.66534C9.32541 9.66534 10.0716 8.91916 10.0716 7.99869C10.0716 7.07822 9.32541 6.33203 8.40494 6.33203C7.48447 6.33203 6.73828 7.07822 6.73828 7.99869C6.73828 8.91916 7.48447 9.66534 8.40494 9.66534Z"
                                                  fill="#444444"
                                                />
                                                <path
                                                  d="M8.40494 16.0013C9.32541 16.0013 10.0716 15.2551 10.0716 14.3346C10.0716 13.4142 9.32541 12.668 8.40494 12.668C7.48447 12.668 6.73828 13.4142 6.73828 14.3336C6.73828 15.2541 7.48447 16.0013 8.40494 16.0013Z"
                                                  fill="#444444"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_841_17">
                                                  <rect
                                                    width={16}
                                                    height={16}
                                                    fill="white"
                                                    transform="translate(0.40625)"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            {dropdowns[itemIndex]
                                              ?.trainedappsAction &&
                                              createPortal(
                                                <ul
                                                  id={`dropdown-linkAction-${itemIndex}`}
                                                  className={`status_dropdown_list absolute z-10 !w-[142px] overflow-hidden rounded-[8px]`}
                                                  style={{
                                                    top: `${dropdownPosition.top}px`,
                                                    left: `${dropdownPosition.left}px`,
                                                    zIndex: 999,
                                                    ...(fromOutgrow && {
                                                      fontFamily:
                                                        '"Ubuntu", sans-serif',
                                                    }),
                                                  }}
                                                >
                                                  <li
                                                    // className="flex cursor-pointer items-center gap-[6px]"
                                                    className={`flex cursor-pointer items-center gap-[6px] ${innerItem?.status === "In Progress" ? "pointer-events-none opacity-50" : ""}`}
                                                    onClick={() => {
                                                      handleViewDetails(
                                                        innerItem.title,
                                                        innerItem.status,
                                                        innerItem,
                                                        itemIndex,
                                                        "file",
                                                      );
                                                    }}
                                                  >
                                                    <ViewDetailsIcon />
                                                    View Details
                                                  </li>
                                                  <li
                                                    className="flex cursor-pointer items-center gap-[6px]"
                                                    onClick={() => {
                                                      if (
                                                        fileDeleteLoader[
                                                          item.key
                                                        ]?.includes(
                                                          innerItem?.id ||
                                                            innerItem.title,
                                                        )
                                                      )
                                                        return;
                                                      handleFileRemove(
                                                        deleteTrainDocument,
                                                        {
                                                          source: innerItem,
                                                          sourceType: item.key,
                                                          size: innerItem?.size,
                                                          fileId:
                                                            innerItem?.id ||
                                                            innerItem.title,
                                                          itemIndex: itemIndex,
                                                        },
                                                      );
                                                      handleDropdowns(
                                                        itemIndex,
                                                        "trainedappsAction",
                                                        false,
                                                      );
                                                    }}
                                                  >
                                                    <DelIconSvg />
                                                    Delete
                                                  </li>
                                                </ul>,
                                                document.getElementById(
                                                  "dropdown-portal",
                                                ) as HTMLElement,
                                              )}
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <div className="no_links_fetched pd-30 h-100 grid place-items-center">
                                    <img
                                      src="https://dlvkyia8i4zmz.cloudfront.net/7eUKmJsvR0OTNIC4DKVQ_1.svg"
                                      alt="no items available"
                                    />
                                  </div>
                                )}
                              </tbody>
                            </table>
                            <div className="!border-[rgba(0, 0, 0, 0.10)] flex h-[60px] w-full items-center justify-between overflow-hidden rounded-b-[10px] !border bg-[#f9f9f9] px-[30px] py-[16px]">
                              <Pagination
                                currentPage={pageValue}
                                totalPages={Math.ceil(
                                  filteredDocs.length / itemsPerPage,
                                )}
                                totalItems={filteredDocs.length}
                                itemsPerPage={itemsPerPage}
                                onPageChange={(newPage) =>
                                  setNativeAppPage((prev) => ({
                                    ...prev,
                                    [item.key]: newPage,
                                  }))
                                }
                                showFirstLast={true}
                                showItemsInfo={true}
                              />
                            </div>
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {leaveModal && (
          <ModalWrapper>
            <BooleanModal
              onConfirm={() => {
                router("/settings");
                buyAddOn
                  ? dispatch(userSlice.actions.setSettings(6))
                  : dispatch(userSlice.actions.setSettings(2));
              }}
              onCancel={() => setLeaveModal(false)}
            />
          </ModalWrapper>
        )}
      </div>
    </motion.div>
  );
};

export default NativeApps;

const appCards: Array<{
  title: string;
  subtitle: string;
  icon: any;
  key: ConfigId;
  titleKey?: string;
}> = [
  {
    title: "Notion",
    subtitle: "Ingest pages from Notion",
    icon: <NotionIcon />,
    key: "notion",
  },
  {
    title: "Confluence",
    subtitle: "Ingest pages or blogposts from Confluence",
    icon: <ConfluenceIcon />,
    key: "confluence",
  },
  {
    title: "Salesforce",
    subtitle: "Ingest articles from Salesforce",
    icon: <SalesforceIcon />,
    key: "salesforce",
  },
  {
    title: "Google Drive",
    subtitle: "Ingest files from Google Drive",
    icon: <GoogleDriveIcon />,
    key: "googlepicker",
  },
];
